/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Colors } from '@chakra-ui/react';
import { customColors } from './Colors';

const inBuiltColors = {
  crimsonRed: 'crimsonRed',
  primary: 'primary',
  primaryDark: 'primaryDark',
  primaryBackground: 'primaryBackground',
} as const;
const finalColors = [...Object.keys(inBuiltColors), ...Object.keys(customColors)];

export const ColorAttributes = [...finalColors] as const;
export type ColorAttribute = (typeof ColorAttributes)[number];

export type KaryaColorTheme = { [key in ColorAttribute]: Colors | string };

const generateColorKeysObject = <T extends Record<string, string>>(colorObject: T): Record<keyof T, keyof T> => {
  return Object.keys(colorObject).reduce(
    (result, key) => {
      result[key as keyof T] = key.toString() as keyof T;
      return result;
    },
    {} as Record<keyof T, keyof T>,
  );
};

export const ColorMap = {
  ...generateColorKeysObject({
    ...inBuiltColors,
    ...customColors,
  }),
} as const;
